import EdFlow from './src/index.vue'

/* istanbul ignore next */
EdFlow.install = function (Vue) {
    Vue.component(EdFlow.name, EdFlow)
}

export default EdFlow
